import React from 'react';

import Divisions  from 'components/Tvendo/Sale/QuotaBPartner/Arcor/Divisions/List.js';

export default function () {
  return <Divisions  />;
}
